import * as AvatarPrimitive from "@radix-ui/react-avatar"
import clsx from "clsx"

import { Text } from "../Text"
import styles from "./Avatar.module.css"

export interface AvatarProps {
  imageUrl?: string
  firstName: string
  lastName: string
  hasBorder?: boolean
  size?: 24 | 32
}

export function Avatar(props: AvatarProps) {
  const { imageUrl, firstName, lastName, hasBorder = true, size = 32 } = props

  const initials = (firstName.charAt(0) + lastName.charAt(0)).toUpperCase()

  return (
    <AvatarPrimitive.Root
      className={clsx(styles.root, hasBorder && styles.border)}
      style={{ width: size, height: size }}
    >
      <AvatarPrimitive.Image src={imageUrl} className={styles.image} />
      <AvatarPrimitive.Fallback delayMs={600}>
        <Text color="grey11" variant="smallBold">
          {initials}
        </Text>
      </AvatarPrimitive.Fallback>
    </AvatarPrimitive.Root>
  )
}
